import React from "react";
import { Box, Container, Grid, Typography, Stack, Link as MuiLink, IconButton } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaInstagram, FaFacebookF, FaWhatsapp } from "react-icons/fa";
import { useConsent } from "../CookieConsent/ConsentContext";

const sedes = [
  {
    city: "Sant Andreu de la Barca",
    address: "Carrer Anoia 29–31",
    email: "info@mesvida.com",
    to: "/santandreu",
  },
  {
    city: "Martorell",
    address: "Av. Dr. Francesc Massana, 17",
    email: "info.martorell@mesvida.com",
    to: "/martorell",
  },
];

const linkStyle = {
  color: "#B7B7BE",
  textDecoration: "none",
  "&:hover": { color: "#fff" },
};

const Footer = () => {
  const { openSettings } = useConsent();

  return (
    <Box component="footer" sx={{ backgroundColor: "#0E0E10", color: "#fff", pt: 8, pb: 4 }}>
      <Container maxWidth="lg">
        <Grid container spacing={5}>
          <Grid item xs={12} md={4}>
            <Typography variant="h3" component="p" sx={{ color: "#fff", mb: 1 }}>
              Mes<Box component="span" sx={{ color: "#E63644" }}>Vida</Box>
            </Typography>
            <Typography variant="body2" sx={{ color: "#B7B7BE", mb: 2.5, maxWidth: 320 }}>
              Gimnasio y entrenamiento personal en Sant Andreu de la Barca y Martorell.
              Para nosotros no eres uno más, eres tú.
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton aria-label="Instagram" href="https://instagram.com" target="_blank" rel="noopener noreferrer" sx={{ color: "#fff", border: "1px solid rgba(255,255,255,0.2)" }}>
                <FaInstagram size={18} />
              </IconButton>
              <IconButton aria-label="Facebook" href="https://facebook.com" target="_blank" rel="noopener noreferrer" sx={{ color: "#fff", border: "1px solid rgba(255,255,255,0.2)" }}>
                <FaFacebookF size={18} />
              </IconButton>
              <IconButton aria-label="WhatsApp" href="https://wa.me/+34692871659" target="_blank" rel="noopener noreferrer" sx={{ color: "#fff", border: "1px solid rgba(255,255,255,0.2)" }}>
                <FaWhatsapp size={18} />
              </IconButton>
            </Stack>
          </Grid>

          {sedes.map((s) => (
            <Grid item xs={12} sm={6} md={3} key={s.city}>
              <Typography variant="h5" component="p" sx={{ color: "#fff", mb: 2 }}>
                {s.city}
              </Typography>
              <Stack spacing={1.25} sx={{ color: "#B7B7BE" }}>
                <Stack direction="row" spacing={1.25} alignItems="flex-start">
                  <FaMapMarkerAlt color="#E63644" style={{ marginTop: 3 }} />
                  <Typography variant="body2">{s.address}</Typography>
                </Stack>
                <Stack direction="row" spacing={1.25} alignItems="center">
                  <FaPhoneAlt color="#E63644" />
                  <MuiLink href="tel:+34692871659" sx={linkStyle}>(+34) 692 87 16 59</MuiLink>
                </Stack>
                <Stack direction="row" spacing={1.25} alignItems="center">
                  <FaEnvelope color="#E63644" />
                  <MuiLink href={`mailto:${s.email}`} sx={linkStyle}>{s.email}</MuiLink>
                </Stack>
                <MuiLink component={RouterLink} to={s.to} sx={{ ...linkStyle, fontWeight: 600 }}>
                  Ver esta sede →
                </MuiLink>
              </Stack>
            </Grid>
          ))}

          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h5" component="p" sx={{ color: "#fff", mb: 2 }}>
              Información legal
            </Typography>
            <Stack spacing={1.25}>
              <MuiLink component={RouterLink} to="/aviso-legal" sx={linkStyle}>Aviso legal</MuiLink>
              <MuiLink component={RouterLink} to="/politica-privacidad" sx={linkStyle}>Privacidad</MuiLink>
              <MuiLink component={RouterLink} to="/politica-cookies" sx={linkStyle}>Cookies</MuiLink>
              <MuiLink component="button" type="button" onClick={openSettings} sx={{ ...linkStyle, textAlign: "left" }}>
                Configurar cookies
              </MuiLink>
            </Stack>
          </Grid>
        </Grid>

        <Box sx={{ borderTop: "1px solid rgba(255,255,255,0.1)", mt: 6, pt: 3 }}>
          <Typography variant="body2" sx={{ color: "#8A8A92", textAlign: "center" }}>
            © {new Date().getFullYear()} MesVida Fitness. Todos los derechos reservados.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
